import { types } from "../types/types";

const initial = {
    filtrosVisorAsignacion: {
      searchId: "",
      searchOrigen: "",
      searchDestino: "",
      filteredServicios: [],
      filteredTipos: [],
      searchServicio: "",
      openKeys: [],
    },
    filtrosVisorSeguimiento: {
      searchId: "",
      searchProveedor: "",
      searchUbicacion: "",
      openKeys: [],
    }
}
export const semaforoReducer = (state = initial, action) => {
  switch (action.type) {

    case types.setFiltrosVisorAsignacion:
      return {
        ...state,
        filtrosVisorAsignacion: {
          ...state.filtrosVisorAsignacion,
          ...action.payload,
        },
      };

    case types.setFiltrosVisorSeguimiento:
      return {
        ...state,
        filtrosVisorSeguimiento: {
          ...state.filtrosVisorSeguimiento,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};
